var map = {
	"./App": "3dfd",
	"./App.vue": "3dfd",
	"./assets/fonts/OpenSans-Bold.woff2": "61c7",
	"./assets/fonts/OpenSans-Light.woff2": "82e7a",
	"./assets/fonts/OpenSans-Regular.woff2": "9635",
	"./assets/fonts/OpenSans-Semibold.woff2": "6485",
	"./assets/i18n/de": "2be1",
	"./assets/i18n/de.json": "2be1",
	"./assets/i18n/en": "6a6a",
	"./assets/i18n/en.json": "6a6a",
	"./assets/i18n/es": "645f",
	"./assets/i18n/es.json": "645f",
	"./assets/i18n/fr": "6f77",
	"./assets/i18n/fr.json": "6f77",
	"./assets/i18n/it": "13c1",
	"./assets/i18n/it.json": "13c1",
	"./assets/i18n/nl": "c28c",
	"./assets/i18n/nl.json": "c28c",
	"./assets/i18n/pl": "e819",
	"./assets/i18n/pl.json": "e819",
	"./assets/images/BestChoice_Logo_4c_pos_grau.svg": "ca67",
	"./assets/images/HowToArrow.png": "e8e7",
	"./assets/images/cadooz-logo.png": "896d",
	"./assets/images/cadooz_footer_logo.svg": "3102",
	"./assets/images/de.png": "a46d",
	"./assets/images/de.svg": "29f1",
	"./assets/images/etracker_logo.png": "69df",
	"./assets/images/feature_checkout.svg": "8490",
	"./assets/images/feature_choose_reward.svg": "6c52",
	"./assets/images/feature_enter_code.svg": "6746",
	"./assets/images/logo.png": "9d64",
	"./assets/images/new-newsletter-image.png": "8154",
	"./assets/images/newsletter-img.png": "c94a",
	"./assets/images/placeholder.png": "aa6f",
	"./assets/images/tuev_logo.png": "e89e",
	"./assets/styles/_extends.scss": "1ff1",
	"./assets/styles/_global.scss": "c48f",
	"./assets/styles/_mixins.scss": "38eb",
	"./assets/styles/_shared.scss": "3c06",
	"./assets/styles/_swiper.scss": "02dc",
	"./assets/styles/bootstrap/_badge.scss": "d69c",
	"./assets/styles/bootstrap/_buttons.scss": "2f43",
	"./assets/styles/bootstrap/_card.scss": "8d07",
	"./assets/styles/bootstrap/_carousel.scss": "1906",
	"./assets/styles/bootstrap/_custom-forms.scss": "ba59",
	"./assets/styles/bootstrap/_dropdown.scss": "f5fa",
	"./assets/styles/bootstrap/_forms.scss": "ea03",
	"./assets/styles/bootstrap/_functions.scss": "9e17",
	"./assets/styles/bootstrap/_index.scss": "efbb",
	"./assets/styles/bootstrap/_nav.scss": "c3da",
	"./assets/styles/bootstrap/_popover.scss": "5311",
	"./assets/styles/bootstrap/_variables.scss": "1d3c",
	"./assets/styles/main.scss": "2fb4",
	"./assets/styles/overwrites/_classes.scss": "a265",
	"./assets/styles/overwrites/_variables.scss": "0c1b",
	"./assets/svg/arrow-left.svg": "f6db",
	"./assets/svg/arrow-right.svg": "8281",
	"./assets/svg/cadooz-logo.svg": "31c6",
	"./assets/svg/caret-down-fill.svg": "aff4",
	"./assets/svg/cart3.svg": "4abc",
	"./assets/svg/catIcon10.svg": "19c4",
	"./assets/svg/catIcon13093.svg": "f61c",
	"./assets/svg/catIcon14.svg": "bf91",
	"./assets/svg/catIcon15.svg": "8430",
	"./assets/svg/catIcon297.svg": "bc18",
	"./assets/svg/catIcon332.svg": "4fed",
	"./assets/svg/catIcon339.svg": "93db",
	"./assets/svg/catIcon5.svg": "3dd9",
	"./assets/svg/catIcon6.svg": "7c63",
	"./assets/svg/catIcon689.svg": "ef30",
	"./assets/svg/catIcon8.svg": "b832",
	"./assets/svg/catIcon9.svg": "2ff8",
	"./assets/svg/catIconDefault.svg": "851d",
	"./assets/svg/chevron-right.svg": "f0c2",
	"./assets/svg/credit-card.svg": "1ad3",
	"./assets/svg/dropdown-down.svg": "b244",
	"./assets/svg/exclamation-triangle.svg": "c81f",
	"./assets/svg/flags/de.svg": "63d7",
	"./assets/svg/flags/en.svg": "2b06",
	"./assets/svg/flags/es.svg": "37fe",
	"./assets/svg/flags/fr.svg": "2d7a",
	"./assets/svg/flags/it.svg": "0976",
	"./assets/svg/flags/nl.svg": "fe37",
	"./assets/svg/flags/pl.svg": "641c",
	"./assets/svg/forgot-password-icon.svg": "de03",
	"./assets/svg/gear-fill.svg": "c504",
	"./assets/svg/hide-password-icon.svg": "20b6",
	"./assets/svg/laptop.svg": "2fdb",
	"./assets/svg/left-arrow.svg": "6e27",
	"./assets/svg/list.svg": "484a",
	"./assets/svg/logout.svg": "a861",
	"./assets/svg/password-check.svg": "0254",
	"./assets/svg/person.svg": "7c75",
	"./assets/svg/phone.svg": "1f9a",
	"./assets/svg/printer.svg": "0097",
	"./assets/svg/right-arrow.svg": "1dd0",
	"./assets/svg/search.svg": "0a17",
	"./assets/svg/shop.svg": "e158",
	"./assets/svg/show-password-icon.svg": "38d6",
	"./assets/svg/trustpilotIcon.svg": "2370",
	"./assets/svg/x.svg": "2f4c",
	"./components/AdressForm/AddressForm": "a3c4",
	"./components/AdressForm/AddressForm.vue": "a3c4",
	"./components/AffiliateModal": "bc33",
	"./components/AffiliateModal.vue": "bc33",
	"./components/Basket/BasketItem": "ff8f",
	"./components/Basket/BasketItem.vue": "ff8f",
	"./components/Basket/BasketItemGroup": "ce80",
	"./components/Basket/BasketItemGroup.vue": "ce80",
	"./components/Basket/BasketSideBar": "b720",
	"./components/Basket/BasketSideBar.vue": "b720",
	"./components/Basket/BasketSummary": "3612",
	"./components/Basket/BasketSummary.vue": "3612",
	"./components/Basket/BasketSummaryLegalText": "8b97",
	"./components/Basket/BasketSummaryLegalText.vue": "8b97",
	"./components/Categories/CategorieThemeSwiper": "dea5",
	"./components/Categories/CategorieThemeSwiper.vue": "dea5",
	"./components/Categories/CategoriesBar": "c61d",
	"./components/Categories/CategoriesBar.vue": "c61d",
	"./components/Categories/CategoriesBarSwiper": "0e7f",
	"./components/Categories/CategoriesBarSwiper.vue": "0e7f",
	"./components/Categories/CategoryItem": "800c",
	"./components/Categories/CategoryItem.vue": "800c",
	"./components/Categories/CategoryThemeItem": "3192",
	"./components/Categories/CategoryThemeItem.vue": "3192",
	"./components/CheckoutNavigation/CheckoutNavigation": "ce0c",
	"./components/CheckoutNavigation/CheckoutNavigation.vue": "ce0c",
	"./components/CodeInputForm": "2802",
	"./components/CodeInputForm.vue": "2802",
	"./components/ConfirmListGroup": "07df",
	"./components/ConfirmListGroup.vue": "07df",
	"./components/Filter/FilterBox": "1349",
	"./components/Filter/FilterBox.vue": "1349",
	"./components/Filter/FilterBoxRadio": "fd5a",
	"./components/Filter/FilterBoxRadio.vue": "fd5a",
	"./components/Filter/FilterBoxRange": "d42a",
	"./components/Filter/FilterBoxRange.vue": "d42a",
	"./components/Filter/FilterBrands": "1f4a",
	"./components/Filter/FilterBrands.vue": "1f4a",
	"./components/Filter/FilterCategories": "da57",
	"./components/Filter/FilterCategories.vue": "da57",
	"./components/Filter/FilterGroup": "39f2",
	"./components/Filter/FilterGroup.vue": "39f2",
	"./components/Filter/FilterMobile": "d7aa",
	"./components/Filter/FilterMobile.vue": "d7aa",
	"./components/Filter/FilterStatusBar": "e03b",
	"./components/Filter/FilterStatusBar.vue": "e03b",
	"./components/Footer/Footer": "5353",
	"./components/Footer/Footer.vue": "5353",
	"./components/ForgotPasswordForm": "e6db",
	"./components/ForgotPasswordForm.vue": "e6db",
	"./components/Header/Header": "bd61",
	"./components/Header/Header.vue": "bd61",
	"./components/Header/HeaderCustomerInfo": "7880",
	"./components/Header/HeaderCustomerInfo.vue": "7880",
	"./components/Header/HeaderLogoContainer": "02f8",
	"./components/Header/HeaderLogoContainer.vue": "02f8",
	"./components/Header/HeaderNavigation": "a001",
	"./components/Header/HeaderNavigation.vue": "a001",
	"./components/HeaderSearchMenu/Header": "505b",
	"./components/HeaderSearchMenu/Header.vue": "505b",
	"./components/HeaderSearchMenu/HeaderMenu": "1441",
	"./components/HeaderSearchMenu/HeaderMenu.vue": "1441",
	"./components/HowToComponent/HowToComponent": "b702",
	"./components/HowToComponent/HowToComponent.vue": "b702",
	"./components/InfoBox/InfoBox": "a2b8",
	"./components/InfoBox/InfoBox.vue": "a2b8",
	"./components/LanguageSwitch": "726d",
	"./components/LanguageSwitch.vue": "726d",
	"./components/LoginInputForm": "d936",
	"./components/LoginInputForm.vue": "d936",
	"./components/NewPasswordForm": "33aa",
	"./components/NewPasswordForm.vue": "33aa",
	"./components/PasswordSuccessForm": "60c1",
	"./components/PasswordSuccessForm.vue": "60c1",
	"./components/Payment/PaymentListGroup": "6e1a",
	"./components/Payment/PaymentListGroup.vue": "6e1a",
	"./components/Payment/PaymentOptionRadio": "8a86",
	"./components/Payment/PaymentOptionRadio.vue": "8a86",
	"./components/PictureCardGroup/PictureCard": "c9a5",
	"./components/PictureCardGroup/PictureCard.vue": "c9a5",
	"./components/PictureCardGroup/PictureCardGroup": "98e5",
	"./components/PictureCardGroup/PictureCardGroup.vue": "98e5",
	"./components/Product/ProductItem": "f389",
	"./components/Product/ProductItem.vue": "f389",
	"./components/Product/ProductItemBig": "6f61",
	"./components/Product/ProductItemBig.vue": "6f61",
	"./components/Product/ProductItemSmall": "9843",
	"./components/Product/ProductItemSmall.vue": "9843",
	"./components/Product/ProductSearch": "5d4c",
	"./components/Product/ProductSearch.vue": "5d4c",
	"./components/Product/ProductSearchAlt": "9aa2",
	"./components/Product/ProductSearchAlt.vue": "9aa2",
	"./components/Product/ProductSearchAltResults": "803a",
	"./components/Product/ProductSearchAltResults.vue": "803a",
	"./components/Product/ProductSlider": "1761",
	"./components/Product/ProductSlider.vue": "1761",
	"./components/ProductDetail/ProductDetailAmount": "f91e",
	"./components/ProductDetail/ProductDetailAmount.vue": "f91e",
	"./components/ProductDetail/ProductDetailBrandSurvey": "8217",
	"./components/ProductDetail/ProductDetailBrandSurvey.vue": "8217",
	"./components/ProductDetail/ProductDetailDeliverySelect": "9be0",
	"./components/ProductDetail/ProductDetailDeliverySelect.vue": "9be0",
	"./components/ProductDetail/ProductDetailDescription": "80e9",
	"./components/ProductDetail/ProductDetailDescription.vue": "80e9",
	"./components/ProductDetail/ProductDetailDescriptionTeaser": "83dd",
	"./components/ProductDetail/ProductDetailDescriptionTeaser.vue": "83dd",
	"./components/ProductDetail/ProductDetailHintConfirmation": "27b1",
	"./components/ProductDetail/ProductDetailHintConfirmation.vue": "27b1",
	"./components/ProductDetail/ProductDetailOrderBar": "2ec0",
	"./components/ProductDetail/ProductDetailOrderBar.vue": "2ec0",
	"./components/ProductDetail/ProductDetailPaymentHint": "691e",
	"./components/ProductDetail/ProductDetailPaymentHint.vue": "691e",
	"./components/ProductDetail/ProductDetailTitle": "97d8",
	"./components/ProductDetail/ProductDetailTitle.vue": "97d8",
	"./components/ProductFilter/ProductFilterOnPage": "ee81",
	"./components/ProductFilter/ProductFilterOnPage.vue": "ee81",
	"./components/Promotion/PromotionBanner": "ad40",
	"./components/Promotion/PromotionBanner.vue": "ad40",
	"./components/Promotion/PromotionTeaser": "d85b",
	"./components/Promotion/PromotionTeaser.vue": "d85b",
	"./components/SliderTwoHandles": "e523",
	"./components/SliderTwoHandles.vue": "e523",
	"./components/Stage/StageBalanceCard": "fb79",
	"./components/Stage/StageBalanceCard.vue": "fb79",
	"./components/Stage/StageDefault": "05c9",
	"./components/Stage/StageDefault.vue": "05c9",
	"./components/Stage/StageDefaultShape": "c27a",
	"./components/Stage/StageDefaultShape.vue": "c27a",
	"./components/Stage/StageLogin": "7e66",
	"./components/Stage/StageLogin.vue": "7e66",
	"./components/Stage/StageLoginCard": "cce7",
	"./components/Stage/StageLoginCard.vue": "cce7",
	"./components/Stage/StageLoginImage": "4170",
	"./components/Stage/StageLoginImage.vue": "4170",
	"./components/Stage/StageLoginShape": "77b0",
	"./components/Stage/StageLoginShape.vue": "77b0",
	"./components/Swiper": "8419",
	"./components/Swiper.vue": "8419",
	"./components/TestForm": "c572",
	"./components/TestForm.vue": "c572",
	"./components/WelcomeStage/WelcomeStage": "26a3",
	"./components/WelcomeStage/WelcomeStage.vue": "26a3",
	"./composables/useSession": "d301",
	"./composables/useSession.js": "d301",
	"./config/addressForm": "e65a",
	"./config/addressForm.js": "e65a",
	"./config/apiErrors": "aa65",
	"./config/apiErrors.js": "aa65",
	"./config/checkoutNavigation": "dad2",
	"./config/checkoutNavigation.js": "dad2",
	"./config/companyUrls": "325a",
	"./config/companyUrls.js": "325a",
	"./config/deliveryTypes": "805f",
	"./config/deliveryTypes.js": "805f",
	"./config/paymentTypes": "c177",
	"./config/paymentTypes.js": "c177",
	"./config/productTypes": "c3a6",
	"./config/productTypes.js": "c3a6",
	"./config/salutations": "325c",
	"./config/salutations.js": "325c",
	"./config/serviceFees": "02c1",
	"./config/serviceFees.js": "02c1",
	"./config/sortingOptions": "7e1a",
	"./config/sortingOptions.js": "7e1a",
	"./config/vatIndexMap": "1f5c",
	"./config/vatIndexMap.js": "1f5c",
	"./helpers/PageLoader": "106f",
	"./helpers/PageLoader.vue": "106f",
	"./helpers/apiErrorHandler": "ce99",
	"./helpers/apiErrorHandler.js": "ce99",
	"./helpers/apiHelpers": "44fa",
	"./helpers/apiHelpers.js": "44fa",
	"./helpers/couponing": "0aeb",
	"./helpers/couponing.js": "0aeb",
	"./helpers/createQuantitySelectOptions": "f140",
	"./helpers/createQuantitySelectOptions.js": "f140",
	"./helpers/filterFunctions": "652f",
	"./helpers/filterFunctions.js": "652f",
	"./helpers/riskIdent": "ecf3",
	"./helpers/riskIdent.js": "ecf3",
	"./helpers/sortingFunctions": "8d60",
	"./helpers/sortingFunctions.js": "8d60",
	"./helpers/utils": "a2b6",
	"./helpers/utils.js": "a2b6",
	"./layouts/Default": "ea2a",
	"./layouts/Default.vue": "ea2a",
	"./layouts/Plain": "af28",
	"./layouts/Plain.vue": "af28",
	"./layouts/Product": "3e68",
	"./layouts/Product.vue": "3e68",
	"./main": "56d7",
	"./main.js": "56d7",
	"./pages/basket": "540a",
	"./pages/basket.vue": "540a",
	"./pages/checkout/address": "a4bf",
	"./pages/checkout/address.vue": "a4bf",
	"./pages/checkout/confirm": "d73f",
	"./pages/checkout/confirm.vue": "d73f",
	"./pages/checkout/confirmation": "871c",
	"./pages/checkout/confirmation.vue": "871c",
	"./pages/checkout/payment": "3c40",
	"./pages/checkout/payment-in-process": "5626",
	"./pages/checkout/payment-in-process.vue": "5626",
	"./pages/checkout/payment.vue": "3c40",
	"./pages/checkout/verify": "ef91",
	"./pages/checkout/verify.vue": "ef91",
	"./pages/error": "5d94",
	"./pages/error-open": "c1bd",
	"./pages/error-open.vue": "c1bd",
	"./pages/error.vue": "5d94",
	"./pages/handshake-error": "1986",
	"./pages/handshake-error.vue": "1986",
	"./pages/handshake-logout": "2d67",
	"./pages/handshake-logout.vue": "2d67",
	"./pages/new-password": "ac96",
	"./pages/new-password.vue": "ac96",
	"./pages/product-details/_product_number": "827b",
	"./pages/product-details/_product_number.vue": "827b",
	"./pages/product-finder": "440e",
	"./pages/product-finder.vue": "440e",
	"./pages/product-overview": "aaa2",
	"./pages/product-overview.vue": "aaa2",
	"./pages/voucher-overview": "28ac",
	"./pages/voucher-overview.vue": "28ac",
	"./pages/welcome": "0462",
	"./pages/welcome.vue": "0462",
	"./plugins/axios": "be3b",
	"./plugins/axios.js": "be3b",
	"./plugins/i18n": "d3a4",
	"./plugins/i18n.js": "d3a4",
	"./plugins/mixins/headerMixin": "02ec",
	"./plugins/mixins/headerMixin.js": "02ec",
	"./plugins/veeValidate": "5fa4",
	"./plugins/veeValidate.js": "5fa4",
	"./plugins/vue-matomo": "faab",
	"./plugins/vue-matomo.js": "faab",
	"./router": "a18c",
	"./router/": "a18c",
	"./router/index": "a18c",
	"./router/index.js": "a18c",
	"./router/routes": "d046",
	"./router/routes.js": "d046",
	"./services/basket": "93d0",
	"./services/basket.js": "93d0",
	"./services/init": "baf4",
	"./services/init.js": "baf4",
	"./services/order": "7e61",
	"./services/order.js": "7e61",
	"./services/password": "ded0",
	"./services/password.js": "ded0",
	"./services/payment": "b0b7",
	"./services/payment.js": "b0b7",
	"./services/punchout": "7a82",
	"./services/punchout.js": "7a82",
	"./services/user": "93d6",
	"./services/user.js": "93d6",
	"./store": "4360",
	"./store/": "4360",
	"./store/index": "4360",
	"./store/index.js": "4360",
	"./store/modules/app": "d9cd",
	"./store/modules/app.js": "d9cd",
	"./store/modules/basket": "aa2d",
	"./store/modules/basket.js": "aa2d",
	"./store/modules/etracker": "e6a4",
	"./store/modules/etracker.js": "e6a4",
	"./store/modules/filter": "8625",
	"./store/modules/filter.js": "8625",
	"./store/modules/order": "2bf4",
	"./store/modules/order.js": "2bf4",
	"./store/modules/pages": "2788",
	"./store/modules/pages.js": "2788",
	"./store/modules/pagination": "d1e4",
	"./store/modules/pagination.js": "d1e4",
	"./store/modules/product": "c2ff",
	"./store/modules/product.js": "c2ff",
	"./store/modules/punchout": "709f",
	"./store/modules/punchout.js": "709f",
	"./store/modules/translation": "1cc0",
	"./store/modules/translation.js": "1cc0",
	"./store/modules/user": "0f9a",
	"./store/modules/user.js": "0f9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a8ec";